




























import { Component, Vue } from 'vue-property-decorator';
import Title from '@/components/Title.vue';
import BusinessReport from '@/components/reports/DailyBusinessReport.vue';
import ReportDate from '@/components/reports/DailyReportDate.vue';
import LevelMixin from '@/mixins/dailyBusinessReport.mixin';

@Component({
  components: { 
    Title, 
    BusinessReport, 
    ReportDate 
  },
  mixins: [LevelMixin]
})
export default class DBReport extends Vue {}
